import Link from "next/link";
import styles from "./Card.module.css";

const BlogCard = ({ blog, transformation = false }) => {
  return (
    <div className="col-6 col-lg-4 mb-4 p-md-3">
      <Link href={"/blogs/" + blog.slug} target="_blank">
        <a>
          <img
            src={
              transformation && blog.transformation_image
                ? blog.transformation_image
                : blog.headerImage[0].image
            }
            className={`w-100 ${styles.cursorPointer}`}
            alt={blog.title}
          />
        </a>
      </Link>

      {!transformation && (
        <>
          <Link href={"/blogs/" + blog.slug} target="_blank">
            <a>
              <div
                className={`${styles.listed_blog_title} ${styles.fo20} ${styles.fw600} text-center ${styles.mfo13} mb-3`}
              >
                {blog.title}
              </div>
            </a>
          </Link>

          <div
            className={`${styles.listed_blog_summary} ${styles.fo14} ${styles.fw400} text-center ${styles.mfo11}`}
          >
            {blog.summary}
          </div>
        </>
      )}
    </div>
  );
};

export default BlogCard;
